const fs = require("fs");
const path = require("path");
const nconf = require("nconf");

/**
 * Gets the output path from command line arguments or defaults to current working directory
 * @returns {string} The resolved output path
 */
const getOutputPath = () => {
  nconf.argv();
  return nconf.get("output") || process.cwd();
};

/**
 * Writes data to a file in the specified output directory
 * @param {string} data - The data to write
 * @param {string} filename - The name of the file to create
 * @param {string} outputPath - The output directory path (optional, defaults to current working directory)
 */
const writeFile = (data, filename, outputPath = null) => {
  const outputDir = path.resolve(outputPath || getOutputPath());
  const outputFile = path.join(outputDir, filename);

  // Ensure the output directory exists
  if (!fs.existsSync(outputDir)) {
    fs.mkdirSync(outputDir, { recursive: true });
  }

  fs.writeFile(outputFile, data, "utf8", (err) => {
    if (err) {
      console.error(`Error writing ${filename}:`, err);
    } else {
      console.log(`${filename} has been saved successfully to: ${outputFile}`);
    }
  });
};

/**
 * Writes JSON data to a file in the specified output directory
 * @param {Object} data - The data object to stringify and write
 * @param {string} filename - The name of the file to create
 * @param {string} outputPath - The output directory path (optional, defaults to current working directory)
 * @param {number} indent - Number of spaces for indentation (optional, defaults to 2)
 */
const writeJsonFile = (data, filename, outputPath = null, indent = 2) => {
  const jsonData = JSON.stringify(data, null, indent);
  writeFile(jsonData, filename, outputPath);
};

module.exports = {
  getOutputPath,
  writeFile,
  writeJsonFile
};